var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.volumes && _vm.volumes.length)?_c('div',{staticClass:"viewer3d"},[_c('div',{ref:"container",staticClass:"container3d"}),_c('ViewportOverlay',_vm._b({attrs:{"voi":_vm.voi}},'ViewportOverlay',_vm.dataDetails,false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }